export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14219.6a0b491d.jpg";